/** Shared, optional footer enhancement. Native scrolling owns every frame. */
export function mountFooter(footer, { enabled = true } = {}) {
  if (!footer) return () => {};
  const main = document.getElementById('main-content');
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const pointer = matchMedia('(hover: hover) and (pointer: fine)');
  const sentinel = document.createElement('div');
  sentinel.className = 'kb-footer-sentinel';
  sentinel.setAttribute('aria-hidden', 'true');
  footer.before(sentinel);
  let disposed = false;
  // Keep keyboard targets still, including after blur. Pointer focus must not
  // cancel a running transform between down/up and move the clicked link.
  const quiet = event => {
    if (event.target.matches(':focus-visible')) footer.setAttribute('data-footer-quiet', '');
  };
  footer.addEventListener('focusin', quiet);
  const measure = () => {
    if (disposed) return;
    // Tall/touch/reading footers stay in flow so every link is reachable.
    const eligible = enabled && !motion.matches && pointer.matches && main &&
      footer.offsetHeight < innerHeight - 80 && main.offsetHeight > innerHeight + footer.offsetHeight / 2;
    footer.toggleAttribute('data-footer-reveal', !!eligible);
  };
  const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
  resize?.observe(footer);
  if (main) resize?.observe(main);
  const enter = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    if (entries.some(e => e.isIntersecting)) {
      footer.setAttribute('data-footer-entered', '');
      enter.disconnect();
    }
  }) : null;
  enter?.observe(sentinel);
  motion.addEventListener('change', measure);
  pointer.addEventListener('change', measure);
  window.addEventListener('resize', measure);
  document.fonts?.ready.then(measure);
  measure();
  return () => {
    disposed = true;
    resize?.disconnect(); enter?.disconnect(); sentinel.remove();
    motion.removeEventListener('change', measure);
    pointer.removeEventListener('change', measure);
    window.removeEventListener('resize', measure);
    footer.removeEventListener('focusin', quiet);
    footer.removeAttribute('data-footer-reveal');
    footer.removeAttribute('data-footer-entered');
    footer.removeAttribute('data-footer-quiet');
  };
}

// The static shell loads this same module, not a second implementation.
if (typeof document !== 'undefined' && document.body?.classList.contains('kb-body')) {
  mountFooter(document.querySelector('[data-testid="site-footer"]'), {
    enabled: document.body.classList.contains('kb-surface-marketing'),
  });
}
